import { buildHref } from "@softmax/web-addresses";
import { leagueRoute, slugifyLeagueName } from "@softmax/web-features/leagues";
import {
  curatedCoworldName,
  curatedText,
} from "@softmax/web-features/coworlds";

import { type GamePageContext } from "../../game-types";
import { resolveGameLeague } from "./league";

export async function resolvePublicCoworld({
  signal,
  publicAddress,
  context = null,
}: {
  signal?: AbortSignal | undefined;
  publicAddress: string;
  context?: GamePageContext | null;
}) {
  const resolution = await resolveGameLeague({
    signal,
    publicAddress,
    context,
  });

  if (resolution.status !== "ok") return resolution;

  const { league } = resolution;
  const coworldName = league.game.coworld_name;

  if (!coworldName) return { status: "not-found" } as const;

  const game = league.game.game_address;

  if (!game) throw new Error(`Missing game address for league ${league.id}`);

  const route = leagueRoute(league);
  const settings = league.settings as
    | {
        ladder?: {
          divisions?: {
            division_id?: unknown;
          }[];
        };
      }
    | null
    | undefined;
  const divisionId = settings?.ladder?.divisions?.[0]?.division_id;
  return {
    status: "ok" as const,
    league,
    coworldName,
    displayName: curatedCoworldName(coworldName) ?? league.game.name,
    slug: slugifyLeagueName(coworldName),
    path: buildHref({ name: "game.home", game }),
    route,
    coworldId:
      league.game.coworld_id ?? league.game.canonical_coworld_id ?? null,
    leagueId: league.id,
    divisionId: typeof divisionId === "string" ? divisionId : null,
    description: league.game.description
      ? curatedText(league.game.description)
      : null,
  };
}
